import { SSR_MODE } from '../constants/index'

const runtime = {
    env: 'local',
    pageMode: SSR_MODE, // ssr/export/download
    // routeNameMap: {},
    routeConfig: {},
    shouldLog: false,
    shouldReport: true,
    deviceLevel: 'NOT_READY',
    whiteApiDomain: ['akulaku.com', 'silvrrplus.com']
}

export default {
    set(param, value) {
        if (runtime.hasOwnProperty(param)) {
            if(Array.isArray(runtime[param])){
                runtime[param] = runtime[param].concat(value)
            }else{
                runtime[param] = value
            }
            return true
        } else {
            return false
        }
    },
    get(param) {
        if (runtime.hasOwnProperty(param)) {
            return runtime[param]
        } else {
            return false
        }
    }
}

// 是否离线包模式
export const isOfflineEnv = () => {
  return !!window.__AL_OFFLINE_ENABLE;
}
